<template>
  <div class="question-checkbox">
    <div class="choices-options">
        <div class="form-group form-inline pt-1 pb-1 no-gutters">
            <label for="addNoneOfTheAbove" class="control-label pr-1">Include None of the Above</label>
            <input type="checkbox" id="addNoneOfTheAbove" name="addNoneOfTheAbove" 
                v-model="addNoneOfTheAbove" true-value="Y" false-value="N" 
                @click="checkAddNoneOfTheAbove($event)" />
      </div>
      <div class="form-group form-inline pt-1 pb-1 no-gutters">
        <label for="orderSet" >Order</label>
        <div class="form-check form-check-inline">
            <input type="radio" id="orderRandom" name="orderRandom" class="form-check-input" value="random"  v-model="choiceOrder" @click="saveOrderEvent($event);saveChoice()">Random 
        </div>
        <div class="form-check form-check-inline">
            <input type="radio" id="orderSet" name="orderSet" class="form-check-input" value="set" v-model="choiceOrder" @click="saveOrderEvent($event);saveChoice()">Set (below) 
        </div>
      </div>        
      <div v-show="draggableEnabled" class="question-order">
        <div class="message pl-2">Drag and Drop a choice's name to set the order of how they will always appear in the survey.</div>
        <VueDraggable
            v-model="choices"
            :disabled="!draggableEnabled"
            class="list-group draggable-container"
            ghost-class="draggable-ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="endOfDragChoices"
            options="people"            
        >
            <div v-show="choice.name != ''" class="list-group-item draggable-card" v-for="choice in this.choices" 
                :key="choice.questionId" 
                :index="choice.questionId">
                <i class="fa fa-caret-right" aria-hidden="true"></i>
                <span class="pl-1">{{ choice.name }}</span>
            </div>
        </VueDraggable>      
      </div>
    </div>
  </div>
</template>
<script>
import { VueDraggable } from 'vue-draggable-plus';

import DragAndDropMixins from "../mixins/DragAndDropMixins.vue";
export default {
  name: "QuestionRadioButton",
  components: {VueDraggable},
  mixins: [DragAndDropMixins],
  computed: {},
  watch: {
    initialChoices: function(){
      this.choices = this.initialChoices;
    },
    initialAddNoneOfTheAbove: function(){
      this.addNoneOfTheAbove = this.initialAddNoneOfTheAbove;
    },    
  },
  data() {
    return {
      addNoneOfTheAbove: "N",
    };
  },
  props: {
    initialAddNoneOfTheAbove: {
        type: String,
        value: "N"
    },    
  },
  methods: {
    checkAddNoneOfTheAbove: function(event){
      if (event.target.checked) {
        this.addNoneOfTheAbove = "Y";
      } else {
        this.addNoneOfTheAbove = "N";
      }
      this.saveNoneOfTheAbove();
    },    
    saveDragDrop: function(){
        this.saveChoice();
    },
    saveNoneOfTheAbove: function(){
        this.$emit("saveNoneOfTheAbove", this.addNoneOfTheAbove);
    },
    saveChoice: function(){
        this.$emit("saveOrder",this.choices, this.choiceOrder, this.addNoneOfTheAbove);
    },
    setChoiceOrder: function(event){
      if (typeof this.initialChoiceOrder !== 'undefined'){
        this.choiceOrder = this.initialChoiceOrder;
      } else {
        this.choiceOrder = "set";
      }
    },
  },
  mounted() {
    this.setChoiceOrder();
    this.addNoneOfTheAbove = this.initialAddNoneOfTheAbove;
  },  
  unmounted() {}
};
</script>
